import { createContext, useContext, useState } from "react";

const ModalContext = createContext(null);

// 외부(openAlert 등)에서 접근 가능하도록 컨트롤러 노출
export let modalController = null;

export function ModalProvider({ children }) {
  const [stack, setStack] = useState([]);

  const open = ({ name, props }) => {
    setStack(prev => [...prev, { name, props }]);
  };

  const close = () => {
    setStack(prev => prev.slice(0, -1));
  };

  const closeAll = () => {
    setStack([]);
  };

  const value = {
    stack,
    current: stack.at(-1) || null,
    open,
    close,
    closeAll,
  };

  // 컨트롤러 바인딩 (1회)
  modalController = value;

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModalContext() {
  return useContext(ModalContext);
}
